/**
 * Le palette ritirate dagli elenchi, con i colori che avevano.
 *
 * Servono a mantenere una promessa: chi aveva scelto "Sabbia" o "Crema/Nero" non deve
 * trovarsi la scacchiera cambiata sotto gli occhi perché abbiamo accorciato una lista. Al
 * caricamento il tema ritirato diventa 'custom' con questi stessi due colori — l'aspetto
 * resta, e da lì l'utente può continuare a modificarlo liberamente.
 *
 * QUESTO ELENCO SI È SVUOTATO QUASI TUTTO, e la ragione dice come si usa: sette delle
 * dieci palette ritirate sono tornate in elenco per nome (corallo, verde/viola, rosa/blu
 * notte, mogano, oceano, viola/lavanda, rosa). Rimetterle SENZA toglierle da qui non
 * avrebbe funzionato: la conversione gira per prima, quindi il tema appena scelto sarebbe
 * ridiventato "Personalizzato…" al ricaricamento successivo. Restano le tre che erano
 * davvero doppioni — crema/nero, sabbia, ardesia — e per quelle la promessa vale ancora.
 *
 * Il file non importa NIENTE di proposito. Lo legge lo store delle preferenze, che gira
 * al caricamento del modulo: tirarci dentro `piece-themes` significherebbe tirarci dentro
 * anche il catalogo di rendering e i livelli di dettaglio dei pezzi, per quattro coppie di
 * esadecimali.
 *
 * Non è una migrazione una-tantum e non si può cancellare alla prossima release: zustand
 * scrive lo storage PRIMA della reidratazione, e il server rieccheggia il valore che ha
 * salvato. L'id ritirato resta dov'è e viene riconvertito a ogni avvio.
 */
export interface RetiredColors {
  light: string;
  dark: string;
}

/**
 * Caselle: i valori sono copiati alla lettera dal vecchio `BOARD_THEME_COLORS`, quindi la
 * conversione è esatta — con 'custom' i due esadecimali SONO i colori di casella, senza
 * rielaborazioni.
 */
export const RETIRED_BOARD_COLORS: Record<string, RetiredColors> = {
  sand: { light: '#F5E6C8', dark: '#B99A63' },
  slate: { light: '#A9B4C0', dark: '#5C6874' },
};

/**
 * Pedine: la tinta base di ciascun lato, cioè la tappa al 35% del vecchio gradiente. È
 * quella e non un'altra perché `gradientFromBase` costruisce le quattro tappe proprio da
 * lì (schiarita del 20%, base, scurita del 14%, scurita del 28%).
 *
 * Qui la conversione NON è esatta: `resolvePieceColors('custom', …)` rigenera i bordi e
 * usa le corone dorate generiche, mentre queste palette avevano bordi e corone scelti a
 * mano (l'arancio/blu, per dire, portava una corona scura sul lato arancio). Il pezzo
 * resta della stessa tinta e dello stesso peso; il dettaglio del bordo cambia di poco.
 */
export const RETIRED_PIECE_COLORS: Record<string, RetiredColors> = {
  'cream-black': { light: '#F4ECDA', dark: '#3A3A3A' },
};
